import { Tag, type TableColumnsType } from 'antd';
import type { JobListQuery } from '@chukua/common';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import type { JobListItem } from '../../../jobs.api';

const HOLD_TYPE_LABELS = { manual: 'Manual', credit: 'Credit' } as const;

/** Why and since when, shown while the list is narrowed to On hold; `heldAt` is a sort field in `jobListQuerySchema`. */
export function buildHoldColumns(list: Pick<ListQueryControls<JobListQuery>, 'sortOrderFor'>): TableColumnsType<JobListItem> {
  return [
    { title: 'Hold type', key: 'holdType', render: (_, job) => <Tag>{job.holdReason ? HOLD_TYPE_LABELS[job.holdReason] : '—'}</Tag> },
    { title: 'Hold reason', key: 'holdReasonName', render: (_, job) => job.heldReasonName ?? '—' },
    {
      title: 'Held since',
      key: 'heldAt',
      sorter: true,
      sortOrder: list.sortOrderFor('heldAt'),
      render: (_, job) => (job.heldAt ? new Date(job.heldAt).toLocaleString() : '—'),
    },
  ];
}
